import gql from 'graphql-tag';

export default gql`
    mutation DeleteCrew($input: CrewDeleteRequest) {
        deleteCrew(input: $input) {
            errors
        }
    }
`;
